module.exports = __webpack_public_path__ + "media/images/people/boy-5-d40d07b34ce0bc7995cab1a08417b90a.webp";